const t = "{{currentTime}} 次，共 {{duration}} 次", A = "搜索 {{current}}/{{total}} 个结果", n = "未发现结果", o = "找到 {{count}} 个结果", E = "找到 {{count}} 个结果", c = '从 $t(HOURS, { "count": {{hours}} }) $t(MINUTES, { "count": {{minutes}} }) $t(SECONDS, { "count": {{seconds}} }) 开始播放。', T = '从 $t(MINUTES, { "count": {{minutes}} }) $t(SECONDS, { "count": {{seconds}} }) 开始播放。', _ = '从 $t(SECONDS, { "count": {{seconds}} }) 开始播放。', s = "保存转录文本更改时出错。", S = "{{time}} 位置的转录文本行。内容是：{{text}}。", N = '转录文本行容器。该容器内有 $t(TRANSCRIPT_LINES, { "count": {{count}} }) 行转录文本。请使用向下键在容器内导航。', R = "保存更改...", O = "更改已保存到转录文本。", I = "更新字幕按钮现已可用。", C = "操作", P = "添加注释时间：{{time}}", U = "添加问题时间：{{time}}。", L = "注释", D = "自动", e = "自动 ({{quality}})", M = "返回", u = "字幕说明", G = "字幕语言", Y = "管理说明", H = "删除{{language}}", r = "字体大小", V = "字幕语言：{{language}}", B = "{{language}}（自动）", i = "清除搜索", a = "关闭", K = "评论", m = "继续", F = "降低播放速度", d = "按 {{percent}}% 降低音量", l = "向下箭头", h = "关闭转录文本编辑器", W = "更新字幕", $ = "错误！", g = "正在保存...", Q = "已保存！", J = "编辑转录文本", p = "文本不能为空！", x = "全屏", Z = "{{count}}小时", X = "{{count}} 小时", f = "提高播放速度", q = "按 {{percent}}% 提高音量", v = "反色", y = "跳到特定百分比（1-10%、2-20% 等）", z = "跳到开始", b = "{{title}}操作", j = "键盘捷径", k = "语言", w = "左箭头", tt = "主菜单", At = "{{count}}分钟", nt = "{{count}} 分钟", ot = "静音", Et = "已屏蔽", ct = "下一个字幕语言", Tt = "下一个搜索结果", _t = "关", st = "在顶部", St = "打开注释时间：{{time}}", Nt = "打开已完成的测验时间：{{time}}", Rt = "打开测验时间：{{time}}", Ot = "暂停", It = "播放", Ct = "回放速度", Pt = "播放速度：{{speed}}x", Ut = "上一个字幕语言", Lt = "上一个搜索结果", Dt = "质量", et = "质量菜单", Mt = "播放", ut = "重置播放速度", Gt = "右箭头", Yt = "在转录文本中搜索", Ht = "{{count}} 秒", rt = "{{count}} 秒", Vt = "快退：{{seconds}} 秒", Bt = "快进：{{seconds}} 秒", it = "设置", at = "快捷方式", Kt = "多媒体详情和工具", mt = "空格，空间", Ft = "播放速度菜单", dt = "开始自动滚动", lt = "切换字幕", ht = "切换静音", Wt = "切换播放暂停", $t = "{{count}} 个转录文本行", gt = "{{count}} 个转录文本行", Qt = "正在加载转录文本...", Jt = "无法加载转录文本。", pt = "转录文本选项", xt = "重试", Zt = "转录文本不可用", Xt = "向上箭头", ft = "视频设置", qt = "音量", vt = "音量：{{volume}}%", yt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: A,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: o,
  A11Y_SEARCH_RESULTS_FOUND_other: E,
  A11Y_TIMESTAMP_JUMP_HOURS: c,
  A11Y_TIMESTAMP_JUMP_MINUTES: T,
  A11Y_TIMESTAMP_JUMP_SECONDS: _,
  A11Y_TRANSCRIPT_ERROR: s,
  A11Y_TRANSCRIPT_LINE: S,
  A11Y_TRANSCRIPT_LINES: N,
  A11Y_TRANSCRIPT_SAVING: R,
  A11Y_TRANSCRIPT_SUCCESS: O,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: I,
  ACTION: C,
  ADD_ANNOTATION_AT: P,
  ADD_QUESTION_AT: U,
  ANNOTATIONS: L,
  AUTO: D,
  AUTO_QUALITY: e,
  BACK: M,
  CAPTIONS: u,
  CAPTIONS_LANGUAGE: G,
  CAPTIONS_MANAGE: Y,
  CAPTION_DELETE: H,
  CAPTION_FONT_SIZE: r,
  CAPTION_LANGUAGE: V,
  CAPTION_LANGUAGE_AUTOMATIC: B,
  CLEAR_SEARCH: i,
  CLOSE: a,
  COMMENTS: K,
  CONTINUE: m,
  DECREASE_PLAYBACK_SPEED: F,
  DECREASE_VOLUME: d,
  DOWN_ARROW: l,
  EDIT_CLOSE: h,
  EDIT_CONFIRM: W,
  EDIT_ERROR: $,
  EDIT_SAVING: g,
  EDIT_SUCCESS: Q,
  EDIT_TRANSCRIPT: J,
  EDIT_VALIDATION_ERROR: p,
  FULLSCREEN: x,
  HOURS: Z,
  HOURS_other: X,
  INCREASE_PLAYBACK_SPEED: f,
  INCREASE_VOLUME: q,
  INVERT_COLORS: v,
  JUMP_TO_PERCENTAGE: y,
  JUMP_TO_START: z,
  KEBAB_MENU: b,
  KEYBOARD_SHORTCUTS: j,
  LANGUAGE: k,
  LEFT_ARROW: w,
  MAIN_MENU: tt,
  MINUTES: At,
  MINUTES_other: nt,
  MUTE: ot,
  MUTED: Et,
  NEXT_CAPTION_LANGUAGE: ct,
  NEXT_HIT: Tt,
  OFF: _t,
  ON_TOP: st,
  OPEN_ANNOTATION_AT: St,
  OPEN_COMPLETED_QUIZ_AT: Nt,
  OPEN_QUIZ_AT: Rt,
  PAUSE: Ot,
  PLAY: It,
  PLAYBACK_SPEED: Ct,
  PLAYBACK_SPEED_MESSAGE: Pt,
  PREVIOUS_CAPTION_LANGUAGE: Ut,
  PREVIOUS_HIT: Lt,
  QUALITY: Dt,
  QUALITY_MENU: et,
  REPLAY: Mt,
  RESET_PLAYBACK_SPEED: ut,
  RIGHT_ARROW: Gt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Yt,
  SECONDS: Ht,
  SECONDS_other: rt,
  SEEK_BACKWARD: Vt,
  SEEK_FORWARD: Bt,
  SETTINGS: it,
  SHORTCUT: at,
  SIDEBAR: Kt,
  SPACE: mt,
  SPEED_MENU: Ft,
  START_AUTOSCROLL: dt,
  TOGGLE_CAPTIONS: lt,
  TOGGLE_MUTED: ht,
  TOGGLE_PLAY_PAUSE: Wt,
  TRANSCRIPT_LINES: $t,
  TRANSCRIPT_LINES_other: gt,
  TRANSCRIPT_LOADING: Qt,
  TRANSCRIPT_LOAD_ERROR: Jt,
  TRANSCRIPT_OPTIONS: pt,
  TRANSCRIPT_RETRY: xt,
  TRANSCRIPT_UNAVAILABLE: Zt,
  UP_ARROW: Xt,
  VIDEO_SETTINGS: ft,
  VOLUME: qt,
  VOLUME_VALUE: vt
};
export {
  t as A11Y_DURATION,
  A as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  o as A11Y_SEARCH_RESULTS_FOUND,
  E as A11Y_SEARCH_RESULTS_FOUND_other,
  c as A11Y_TIMESTAMP_JUMP_HOURS,
  T as A11Y_TIMESTAMP_JUMP_MINUTES,
  _ as A11Y_TIMESTAMP_JUMP_SECONDS,
  s as A11Y_TRANSCRIPT_ERROR,
  S as A11Y_TRANSCRIPT_LINE,
  N as A11Y_TRANSCRIPT_LINES,
  R as A11Y_TRANSCRIPT_SAVING,
  O as A11Y_TRANSCRIPT_SUCCESS,
  I as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  C as ACTION,
  P as ADD_ANNOTATION_AT,
  U as ADD_QUESTION_AT,
  L as ANNOTATIONS,
  D as AUTO,
  e as AUTO_QUALITY,
  M as BACK,
  u as CAPTIONS,
  G as CAPTIONS_LANGUAGE,
  Y as CAPTIONS_MANAGE,
  H as CAPTION_DELETE,
  r as CAPTION_FONT_SIZE,
  V as CAPTION_LANGUAGE,
  B as CAPTION_LANGUAGE_AUTOMATIC,
  i as CLEAR_SEARCH,
  a as CLOSE,
  K as COMMENTS,
  m as CONTINUE,
  F as DECREASE_PLAYBACK_SPEED,
  d as DECREASE_VOLUME,
  l as DOWN_ARROW,
  h as EDIT_CLOSE,
  W as EDIT_CONFIRM,
  $ as EDIT_ERROR,
  g as EDIT_SAVING,
  Q as EDIT_SUCCESS,
  J as EDIT_TRANSCRIPT,
  p as EDIT_VALIDATION_ERROR,
  x as FULLSCREEN,
  Z as HOURS,
  X as HOURS_other,
  f as INCREASE_PLAYBACK_SPEED,
  q as INCREASE_VOLUME,
  v as INVERT_COLORS,
  y as JUMP_TO_PERCENTAGE,
  z as JUMP_TO_START,
  b as KEBAB_MENU,
  j as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  w as LEFT_ARROW,
  tt as MAIN_MENU,
  At as MINUTES,
  nt as MINUTES_other,
  ot as MUTE,
  Et as MUTED,
  ct as NEXT_CAPTION_LANGUAGE,
  Tt as NEXT_HIT,
  _t as OFF,
  st as ON_TOP,
  St as OPEN_ANNOTATION_AT,
  Nt as OPEN_COMPLETED_QUIZ_AT,
  Rt as OPEN_QUIZ_AT,
  Ot as PAUSE,
  It as PLAY,
  Ct as PLAYBACK_SPEED,
  Pt as PLAYBACK_SPEED_MESSAGE,
  Ut as PREVIOUS_CAPTION_LANGUAGE,
  Lt as PREVIOUS_HIT,
  Dt as QUALITY,
  et as QUALITY_MENU,
  Mt as REPLAY,
  ut as RESET_PLAYBACK_SPEED,
  Gt as RIGHT_ARROW,
  Yt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Ht as SECONDS,
  rt as SECONDS_other,
  Vt as SEEK_BACKWARD,
  Bt as SEEK_FORWARD,
  it as SETTINGS,
  at as SHORTCUT,
  Kt as SIDEBAR,
  mt as SPACE,
  Ft as SPEED_MENU,
  dt as START_AUTOSCROLL,
  lt as TOGGLE_CAPTIONS,
  ht as TOGGLE_MUTED,
  Wt as TOGGLE_PLAY_PAUSE,
  $t as TRANSCRIPT_LINES,
  gt as TRANSCRIPT_LINES_other,
  Qt as TRANSCRIPT_LOADING,
  Jt as TRANSCRIPT_LOAD_ERROR,
  pt as TRANSCRIPT_OPTIONS,
  xt as TRANSCRIPT_RETRY,
  Zt as TRANSCRIPT_UNAVAILABLE,
  Xt as UP_ARROW,
  ft as VIDEO_SETTINGS,
  qt as VOLUME,
  vt as VOLUME_VALUE,
  yt as default
};
